import { GetServerSideProps } from 'next';
import LoginComponent from '@web-packages/organisms/Unauthorized/Login';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { getCommonPageData } from '../services/getServerSidePropsConfig';
import { authClient } from '../lib/auth-client';
import AnnouncementMessage from '../components/AnnouncementMessage';

const Login = ({ publicHeader = null, footer = null, announcementMessage = null }: any) => {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [isPrimaryLoading, setIsPrimaryLoading] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => { setMounted(true); }, []);

  const handleNext = async () => {
    const timeout = new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('timeout')), 10000)
    );

    setIsPrimaryLoading(true);
    const url = '/sso/check-domain';
    const params = `?${new URLSearchParams({ email: email }).toString()}`;
    let response = null;
    try {
      response = await Promise.race([
        authClient.$fetch(`${url}${params}`),
        timeout
      ]) as { data: any, error: { message: string, status: number, statusText: string } };
    } catch (error) {
      console.log(error);
      setIsPrimaryLoading(false);
      return;
    }

    if (response?.data) {
      var isSso = response.data.isSso;
      if (isSso)
        router.push({ pathname: '/sso', query: { email } }, '/sso');
      else
        router.push({ pathname: '/password', query: { email } }, '/password');
    }
  };

  if (!mounted) return null;

  return (
    <>
      <AnnouncementMessage announcementMessages={announcementMessage} />
      <div
        style={{
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: 0,
          padding: 0,
        }}
      >
        <div>
        <LoginComponent
          emailValue={email}
          onEmailChange={setEmail}
          onPrimaryClick={handleNext}
          isPrimaryLoading={isPrimaryLoading}
          onHelpClick={() => router.push('/help')}
          onSecondaryClick={() => window.open('https://www.sprakservice.se/form/bestall-kundnummer', '_blank')}
        />
        </div>
      </div>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) =>
  getCommonPageData(context, { redirectIfAuthenticated: true });

export default Login;